import BodyText from '../../../atoms/BodyText';
import Icon from '../../../atoms/Icon';
import PrimaryButton from '../../../buttons/PrimaryButton';
import classNames from 'classnames';
import * as styles from './companyProfileHeader.linaria';
function CompanyProfileHeader({ company, className, contactCompany, isPubliclyShared, }) {
    var _a, _b, _c;
    const getPlaceholderImage = (array) => {
        if (array.length > 1) {
            return 'PlaceholderMultiProfession';
        }
        switch ((array === null || array === void 0 ? void 0 : array[0]) || '') {
            case 'Elektriker':
                return 'PlaceholderElectrician';
            case 'Maler':
                return 'PlaceholderMaler';
            case 'Maler/Tapetserer':
                return 'PlaceholderMaler';
            case 'Murer/flislegger':
                return 'PlaceholderMason';
            case 'Rørlegger':
                return 'PlaceholderPlumber';
            case 'Tak/Blikkenslager':
                return 'PlaceholderRoofingConstruction';
            case 'Takentreprenør':
                return 'PlaceholderRoofingConstruction';
            case 'Varmepumpe':
                return 'PlaceholderHeatPump';
            case 'Ventilasjon':
                return 'PlaceholderHeatPump';
            case 'Byggmester':
                return 'PlaceholderBuilder';
            case 'Snekker/Tømrer':
                return 'PlaceholderBuilder';
            default:
                return 'PlaceholderOtherProfession';
        }
    };
    return (<div className={className}>
      {(company === null || company === void 0 ? void 0 : company.companyProfileImage) ? (<div className={styles.coverImage}>
          <img alt={company.companyName} src={company.companyProfileImage}/>
        </div>) :
            (company === null || company === void 0 ? void 0 : company.franchiseCompany) && (<div className={styles.coverImage}>
          <img alt={company.companyName} src={company.franchiseCompany.companyProfileImage}/>
        </div>)}
      <div className={classNames([
            styles.headerWrapper,
            company.companyProfileImage ? 'cover-image-margin' : (((_a = company.franchiseCompany) === null || _a === void 0 ? void 0 : _a.companyProfileImage) ? 'cover-image-margin' : ''),
        ])}>
        <div className={styles.imageWrapper}>
          {(company === null || company === void 0 ? void 0 : company.companyLogoPath) ? (<img alt={company.companyName} src={company === null || company === void 0 ? void 0 : company.companyLogoPath}/>) :
            ((_b = company.franchiseCompany) === null || _b === void 0 ? void 0 : _b.companyLogoPath) ? (<img alt={company.companyName} src={(_c = company.franchiseCompany) === null || _c === void 0 ? void 0 : _c.companyLogoPath}/>) :
                (<Icon icon={getPlaceholderImage(company === null || company === void 0 ? void 0 : company.industryAssociations)} size="stretch" strokeColor="none"/>)}
        </div>
        <div className={styles.nameWrapper}>
          <BodyText tag="span" size="large" className="company-name">
            {company.companyName}{' '}
          </BodyText>
          <BodyText size="small" tag="span">
            <Icon icon="Certificate" size="small"/>
            {company.plantCount} jobber i Boligmappa
          </BodyText>
        </div>
        {!isPubliclyShared && (<div>
            <div className={styles.contactButtonWrapper}>
              <PrimaryButton fill className="contact-button" onClick={() => contactCompany(company)}>
                Kontakt
              </PrimaryButton>
            </div>
          </div>)}
      </div>
    </div>);
}
CompanyProfileHeader.defaultProps = {
    className: null,
};
export default CompanyProfileHeader;
